module.exports = __webpack_public_path__ + "static/media/my-info-gift-bg.d4c42477.png";